export type AnnouncementItem = {
  id: number;
  title: string;
  body: string;
  createdAt: string;
};

export type AnnouncementInboxResponse = {
  items?: AnnouncementItem[];
  Items?: AnnouncementItem[];
};

export const parseAnnouncementInbox = (
  data: AnnouncementInboxResponse | AnnouncementItem[] | null | undefined,
): AnnouncementItem[] => {
  if (!data) {
    return [];
  }

  if (Array.isArray(data)) {
    return data;
  }

  return data.items ?? data.Items ?? [];
};
